export const formActions = {
  SET_FORM_FIELDS: "SET_FORM_FIELDS",
  SET_FORM_STATE: "SET_FORM_STATE",
  CLEAR_ACTIVE_FORM: "CLEAR_ACTIVE_FORM",
  SET_SHOW_FEEDBACK_FORM: "SET_SHOW_FEEDBACK_FORM",
  CLEAR_FORM: "CLEAR_FORM"
};

export const setFormFields = (id, fields, initialValues = {}) => {
  return {
    type: formActions.SET_FORM_FIELDS,
    payload: {
      id,
      fields,
      initialValues
    }
  };
};

export const setFormState = (id, state) => {
  return {
    type: formActions.SET_FORM_STATE,
    payload: {
      id,
      state
    }
  };
};

export const clearActiveForm = () => {
  return {
    type: formActions?.CLEAR_ACTIVE_FORM
  };
};

export const setShowFeedbackForm = (showFeedbackForm) => {
  return {
    type: formActions.SET_SHOW_FEEDBACK_FORM,
    payload: showFeedbackForm
  };
}

export const clearForm = () => {
  return {
    type: formActions.CLEAR_FORM
  }
}